import validator from 'validator'

class ValidateFields {
  validateLength (field, requiredMessage) {
    if (validator.isEmpty(field)) {
      return requiredMessage
    }
    return false
  }

  validateEmail (email, requiredMessage, invalidEmail) {
    if (validator.isEmpty(email)) {
      return requiredMessage
    } else if (!validator.isEmail(email)) {
      return invalidEmail
    }
    return false
  }

  validateReviewLength (review, length, requiredMessage, lengthMessage) {
    if (validator.isEmpty(review)) {
      return requiredMessage
    } else if (review.length < length) {
      return lengthMessage
    }
    return false
  }
}

const validateFields = new ValidateFields()

export { validateFields }
